import { connectRefinementList } from "react-instantsearch-dom";

const RefinementList = () => {
  return null;
};

const FilterAlgoliaSearch = connectRefinementList(RefinementList);

export default FilterAlgoliaSearch;
